<template>
	<!--主子表-->
	<!-- @cell-click="cellclick" -->
	<pl-table
		style="width:99%;"
		ref="tablegrid"
		@sort-change="gridsortchange"
		:height="height"
		:data="tablemain"
		selectTrClass="selectTr"
		:dataChangesScrollTop="istop"
		fixedColumnsRoll
		bigDataCheckbox
		:excess-rows="5"
		:stripe="stripe"
		:highlight-current-row="false"
		inverse-current-row
		header-align="center"
		use-virtual
		:row-height="48"
		:row-class-name="rowclassname"
		@table-body-scroll="gridscroll"
		@selection-change="handleSelectionChange"
		@select="onTableSelect"
		@select-all="selectall"
		@row-dblclick="rowdblclick" 
		:expand-row-keys="expands"
		:row-key="rowkey"
		:header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
		:cell-style="{ padding: '0px',height:'40px' }"
		:key="timestamp"
	>
		<template slot="empty">
			没有查询到符合条件的记录
		</template>
		<pl-table-column type="selection" width="55" v-for="(c, index) in columns" v-if="c.field == 'checkbox'" :key="index" />
		<pl-table-column width="50">
			<template slot-scope="scope">
				<div v-if="scope.row.haschild=='1'" 
				 @click="getExpandsRow(scope.$index,scope.row,!scope.row.expand)">
					<!-- <span v-if="scope.row.expand">{{scope.row.expand}}  收起</span>
					<span v-if="!scope.row.expand">{{scope.row.expand}}展开</span> -->
					<i :class="['el-icon', scope.row.expand? 'el-icon-arrow-down' : 'el-icon-arrow-right']"></i>
				</div>
			</template>
		</pl-table-column>
		<pl-table-column type="expand" width="1">
			<template slot-scope="scope" >
				<tableson
					style="width:85%;margin-top:-20px;margin-left:105px"
					v-loading="loading"
					ref="tablegridexpand"
					:tableData="tablemain[scope.$index].sonDataList"
					:columns="soncolumns"
					isseq="0"
				></tableson>
			</template>
		</pl-table-column>
		<pl-table-column type="index" width="50"  label="序号" v-if="isseq=='1'" />
		<!-- <pl-table-column  width="60" v-if="isseq=='1'">
			<template slot="header">
				<i class="el-icon-setting" style="color:#409eff;margin-right:5px;font-size:14pt" @click="colset"></i>
			</template>
			<template slot-scope="scope" >
				{{scope.$index+1}}
			</template>
		</pl-table-column> -->
		<pl-table-column
			v-for="(c, index) in columns"
			v-if="c.type != 'template' && c.type != 'checkbox' && c.type != '' && c.colshow != 0"
			:key="index"
			:show-overflow-tooltip="true"
			:label="c.title"
			:min-width="c.width + '%'"
			:sortable="c.sortable"
			:align="c.align"
			:prop="c.field"
		>
			<template slot-scope="scope">
				<span v-if="c.type == 'text'">{{ scope.row[c.field] }}</span>
				<!-- <span v-if="c.type == 'switch'">{{ scope.row[c.field] }}</span> 		:active-value="1"
					:inactive-value="0"-->
				<el-checkbox
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'checkbox'"
					@focus="setoldvalue(scope.row)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
				></el-checkbox>

				<div v-if="scope.row[c.field] == '否'">
					<el-switch
						:ref="c.type + '_' + index + '_' + scope.$index"
						v-if="c.type == 'switch'"
						@focus="setoldvalue(scope.row)"
						@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
						v-model="scope.row[c.field]"
						active-value="是"
						inactive-value="否"
					></el-switch>
				</div>
				<div v-if="scope.row[c.field] == '是'">
					<el-switch
						:ref="c.type + '_' + index + '_' + scope.$index"
						v-if="c.type == 'switch'"
						@focus="setoldvalue(scope.row)"
						@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
						v-model="scope.row[c.field]"
						active-value="是"
						inactive-value="否"
					></el-switch>
				</div>
				<el-select
					v-if="c.type == 'select'"
					:ref="c.type + '_' + index + '_' + scope.$index"
					@focus="setoldvalue(scope.row, c)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					v-model="scope.row[c.field]"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				>
					<el-option v-for="item in c.source" :key="item.label" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-select
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'select_filter'"
					filterable
					:filter-method="val => selectFilter(val, c)"
					@focus="setoldvalue(scope.row, c)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					v-model="scope.row[c.field]"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				>
					<el-option v-for="item in c.source" :key="item.label" :label="item.label" :value="item.label"></el-option>
				</el-select>
				<el-input
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'input'"
					@focus="setoldvalue(scope.row)"
					@blur="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					size="mini"
					v-model="scope.row[c.field]"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				></el-input>
				<el-date-picker
					:ref="c.type + '_' + index + '_' + scope.$index"
					v-if="c.type == 'time'"
					v-model="scope.row[c.field]"
					type="datetime"
					size="mini"
					value-format="yyyy-MM-dd HH:mm:ss"
					@focus="setoldvalue(scope.row)"
					@blur="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					@change="handle(c.event, scope.$index, scope.row, c.field, 'change', index)"
					style="width:100%"
					@keyup.native="event => gridkeyupinput(event, index, scope.$index)"
				></el-date-picker>
				<div v-if="c.type == 'openurl'">
					<el-tag v-if="scope.row[c.field] != ''" type="primary" disable-transitions @click="openurl(c, scope.row)">{{ scope.row[c.field] }}</el-tag>
					<span v-else>{{ scope.row[c.field] }}</span>
				</div>
				<!-- 查物流结转订单 -->
				<div v-if="c.type == 'getwl'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 1)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<!-- 查物流不结转订单 -->
				<div v-if="c.type == 'getwl_notrans'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 4)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type == 'getwl_expressid'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="top" width="350" @show="showevent(scope.row, c, 2)">
						<div style="max-height:320px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-timeline>
								<el-timeline-item v-if="index == 0" type="primary" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">
									{{ wl.context }}
								</el-timeline-item>
								<el-timeline-item v-if="index > 0" v-for="(wl, index) in wllist" :key="index" :timestamp="wl.createtime">{{ wl.context }}</el-timeline-item>
							</el-timeline>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type == 'getwl_airwaybill'">
					<el-popover v-if="scope.row[c.field] != ''" trigger="click" placement="right-start" width="900" @show="showevent(scope.row, c, 3)">
						<div style="max-height:380px;overflow-y:auto;padding-left:10px">
							<p style="padding-bottom:10px;cursor:pointer" @click="copyvalue(scope.row[c.field])">单号：{{scope.row[c.field]}}</p>
							<el-table :data="airtitle" style="width:100%">
								<el-table-column prop="destination" label="出发地"></el-table-column>
								<el-table-column prop="origin" label="目的地"></el-table-column>
								<el-table-column prop="pieces" label="件数" width="80"></el-table-column>
								<el-table-column prop="weight" label="重量" width="80"></el-table-column>
								<el-table-column prop="flight_info" label="航班信息"></el-table-column>
							</el-table>
							<pl-table height="260" :data="airinfo.track">
								<pl-table-column
									v-for="(air, airidx) in aircolumns"
									:key="airidx"
									:show-overflow-tooltip="true"
									:label="air.title"
									align="center"
									:min-width="air.width"
									:prop="air.field"
									:excess-rows="5"
									header-align="center"
									use-virtual
								>
									<template slot-scope="cope">
										<span>{{ cope.row[air.field] }}</span>
									</template>
								</pl-table-column>
							</pl-table>
						</div>
						<div slot="reference" class="name-wrapper">
							<el-tag size="medium">{{ scope.row[c.field] }}</el-tag>
						</div>
					</el-popover>
					<span v-if="scope.row[c.field] == ''">{{ scope.row[c.field] }}</span>
				</div>
				<div v-if="c.type=='input_confirm'">
					<el-popover trigger="click" :ref="`popover-${scope.$index}`"  placement="top" :width="c.width+100">
						<div>
							<el-input
							size="mini"
							v-model="updatevalue"
						></el-input>
						</div>
						<div style="text-align: right;margin-top:5px">
							<el-button size="mini"  @click="Closepopover(scope)">取消</el-button> <el-button size="mini" type="primary" @click="UpdateCol(scope,scope.$index,c.field,c.evttype)">确认</el-button>
							</div>
							<el-link slot="reference" icon="el-icon-edit el-icon--right" @click="Openpopover(scope,scope.row[c.field])">{{ scope.row[c.field] }}</el-link>
					</el-popover>
				</div>
			</template>
		</pl-table-column>
		<pl-table-column v-for="(c, idx) in columns" v-if="c.type == 'template' && c.colshow != 0" :key="c.id" :label="c.title" :width="c.width" fixed="right">
			<template slot-scope="scope">
				<label v-for="(t, ix) in c.template" :key="ix" style="margin-left:15px">
					<el-link :type="t.handletype" :icon="t.icon" :underline="false" @click="handle(t.event, scope.$index, scope.row, '', 'click', idx, t.l_id)">
						{{ t.title }}
					</el-link>
				</label>
			</template>
		</pl-table-column>
	</pl-table>
</template>
<script>
import tableson from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableson
	},
	props: {
		//列表数据
		// tablemain: {
		// 	type: Array,
		// 	default: []
		// },
		//列表表头
		columns: {
			type: Array,
			default: function(){
				return [];
			}
		},
		soncolumns: {
			type: Array,
			default: function(){
				return [];
			}
		},
		//列表高度
		gridheight: {
			type: String,
			defualt: ''
		},
		gridwidth: {
			type: String,
			defualt: '0px'
		},
		editcell: {
			type: String,
			default: '0'
		},
		istop: {
			type: Boolean,
			default: false
		},
		rowclassname: {
			type: Function,
			default: () => () => {}
		},
		stripe: {
			type: Boolean,
			default: true
		},
		isseq:{
			type: String,
			default: '1'
		},
		isexpand: {
			type: Boolean,
			default: false
		},
		rowkey:{
			type: String,
			default: ''
		}
	},
	data() {
		return {
			expands:[],
			loading:false,
			oldvalue: {}, //点击列表行时，当前选中行的值，可用于更改操作
			editcellvalue: 0,
			wllist: [],
			height: 10,
			isadmin: 1,
			copyarray: [] ,//select筛选时临时保留的原数据
			airinfo:{},//空运信息
			aircolumns:[{title:'动态',field:'status',width:'280'},{title:'操作地点',field:'airport',width:'70'},{title:'件数',field:'pieces',width:'50'},{title:'重量',field:'weight',width:'70'},{title:'航班号',field:'flight',width:'90'},{title:'操作时间',field:'createtime',width:'130'}],
			airtitle:[],
			updatevalue:'',
			tablemain:[],
			timestamp:0
		};
	},
	created() {
		if(this.gridheight!=undefined)
			this.height = parseInt(this.gridheight.replace('px', ''));
		else 
			this.height='';
	},
	mounted() {
		//debugger
		var that=this;
		// if(this.tablemain!=undefined)
		// 	this.datalist=this.tablemain;//JSON.parse(JSON.stringify(this.tablemain));
		 if(this.isexpand==undefined)
			this.isexpand=false;
		// 	this.SetExpandState(0,this.isexpand);
	},
	methods: {
		// init(param){
		// 	var that=this;
		// 	var index=this.tablemain.length;
		// 	// if(param.isrefresh){
		// 	// 	index=0;
		// 	// 	this.tablemain=JSON.parse(JSON.stringify(param.list));
		// 	// }
		// 	// else{
		// 	// 	debugger
		// 	// 	// var list=JSON.parse(JSON.stringify(param.list));
		// 	// 	// list.forEach(e=>{
		// 	// 	// 	that.tablemain.push(e);
		// 	// 	// });
		// 	// }
		// 	//this.SetExpandState(index,this.isexpand);
		// },
		//获取操作前的原值存放到变量
		setoldvalue(value, col) {
			this.oldvalue = JSON.parse(JSON.stringify(value));
			if (col != undefined) {
				if (col.source != undefined) {
					if (this.copyarray.length == 0) this.copyarray = col.source;
				}
			}
		},
		//操作列按钮事件
		//event--事件  index--行索引  row-列对象  field--列数据字段名  currentevent--触发此方法的事件名，比如change,blur  colindex-列索引  l_id--是模板列时，按钮权限id(跟业务相关)
		handle(event, index, row, field, currentevent, colindex, l_id) {
			var isevent = false;
			if(this.columns[parseInt(colindex)].type=='time'){
				this.gridkeyupinput({keyCode:13},colindex,index);
			}
			else{
				if ((currentevent == this.columns[parseInt(colindex)].evttype)||currentevent=='click') {
					isevent = true;
				}
				if (isevent) {
					this.$emit('gridhandle', {
						event: event,
						index: index,
						row: row,
						field: field,
						l_id: l_id,
						colindex:colindex,
						oldvalue: this.oldvalue
					});
				}
			}
		},
		//列表排序，调用后端方法排序
		gridsortchange(column) {
			if (column.order != null) {
				this.$emit('gridsort', {
					column: column
				});
			}
		},
		//复选框勾选/取消勾选操作
		handleSelectionChange(rows) {},
		//单行勾选事件，全选或者全部取消时不触发此事件
		onTableSelect(rows, row) {
			let selected = rows.length && rows.indexOf(row) !== -1;
			if (selected == 0) {
				selected = false;
			}
			var isall=false;
			if(rows.length == this.tablemain.length)
				isall=true;
			this.$emit('checkboxchange', {
				row: row,
				rows: rows,
				selected: selected,
				selectedall: isall
			});
		},
		// //全选/取消全选
		selectall(rows) {
			//console.log('table', this.tablemain);
			if (rows.length == 0 || rows.length == this.tablemain.length) {
				//当全选或者全部取消时触发
				var isall=false;
				if(rows.length == this.tablemain.length)
					isall=true;
				this.$emit('checkboxchange', {
					row: [],
					rows: [],
					selected: 0,
					selectedall: isall
				});
			}
		},
		//单元格单击事件
		// cellclick(row, column, event) {
		// 	this.$emit('cellclick', {
		// 		column: column,
		// 		row: row
		// 	});
		// },
		showevent(row, col, type) {
			// console.log('显示悬浮',row);
			// console.log('显示列',col);
			var that = this;
			that.wllist = [];
			if (row[col.field] != '') {
				//查物流结转订单
				if (type == 1) {
					var paraminfo = {
						handtype: 1,
						orderid: row.p_pkval
					};
					this.$apipost.get.getwl({ paraminfo: paraminfo }).then(res => {
						if(res.orderlist!=undefined){
							if(res.orderlist.length>0){
								if (res.orderlist[0].list != undefined) {
									that.wllist =res.orderlist[0].list;
								}
								if (that.wllist.length == 0) {
									that.wllist = [{ time: '', context: '暂无物流' }];
								}
							}
						}
					});
				}
				//直接按快递单号查物流
				if (type == 2) {
					this.$apipost.get.Getwaybill_GN({ expressid: row.expressid, expresscode:row.expresscode}).then(res => {
						if (res.list != undefined) {
							that.wllist = res.list;
						}
						if (that.wllist.length == 0) {
							that.wllist = [{ time: '', context: '暂无物流' }];
						}
					});
				}
				if(type==3){//按提单号查询物流
					this.airinfo={};
					this.airtitle=[];
					this.$apipost.get.GetAirway({ airwaybill: row.p_airwaybill}).then(res => {
						console.log('空运结果',res);
						that.airinfo=res;
						that.airtitle.push(JSON.parse(JSON.stringify(res)));
					});
				}
				//查物流不结转订单
				if (type ==4) {
					var paraminfo = {
						handtype: 1,
						orderid: row.p_pkval,
						isupdate:0
					};
					this.$apipost.get.getwl({ paraminfo: paraminfo }).then(res => {
						if(res.orderlist!=undefined){
							if(res.orderlist.length>0){
								if (res.orderlist[0].list != undefined) {
									that.wllist =res.orderlist[0].list;
								}
								if (that.wllist.length == 0) {
									that.wllist = [{ time: '', context: '暂无物流' }];
								}
							}
						}
					});
				}
			}
		},
		gridscroll(e, event) {
			this.$emit('gridscroll', {
				e: e,
				event: event
			});
		},
		openurl(column, row) {
			this.$emit('cellclick', {
				column: column,
				row: row,
				event: 'openurl'
			});
		},
		rowdblclick(row, column, event) {
			this.$emit('rowdblclick', {
				column: column,
				row: row
			});
		},
		//下拉框筛选
		selectFilter(val, col) {
			col.source = JSON.parse(JSON.stringify(col.oldsource));
			if (val) {
				var filter = col.source.filter(item => {
					return item.label.indexOf(val) > -1 || item.value.indexOf(val) > -1;
				});
				if(filter.length>0){
					col.source = filter;
				}else{
					this.$emit('selectFilter', {
						col: col,
						val:val
					});
				}
			}
		},
		gridkeyupinput(event, colindex, rowindex) {
			//console.log('文本框改变');
			if(this.editcell=='0')
				return false;
			if(rowindex==0){
				if(event.keyCode == 38||event.keyCode == 37){
					this.setuparrow();
				}
			}
			//|| event.keyCode == 38  || event.keyCode == 40
			if (event.keyCode == 13 || event.keyCode == 37  || event.keyCode == 39) {
				//得到当前操作列索引
				var cols = this.columns;
				//得到下一个可编辑列索引
				if (colindex > -1) {
					var nextindex = -1;
					var coltype = '';
					if (event.keyCode == 13|| event.keyCode == 39) {//回车 向右
						if(cols[colindex].evttype!=''&&cols[colindex].evttype!=undefined&&event.keyCode == 13){
							this.handle(this.columns[colindex].event, rowindex,this.tablemain[rowindex], this.columns[colindex].field, 'keyup', colindex);
						}
						else{
							colindex = colindex + 1;
							if (colindex== (cols.length-1)) {
								colindex = 0;
								rowindex = rowindex + 1;
							}
							for (var i = colindex; i < cols.length; i++) {
								if (this.checkcoltype(cols[i])) {
									nextindex = i;
									coltype = cols[i].type;
									break;
								}
							}
						}
					} else if (event.keyCode == 37) {//向左
						colindex = colindex - 1;
						if (colindex <= 0) {
							colindex = cols.length - 1;
							rowindex = rowindex - 1;
						}
						for (var i = colindex; i < cols.length; i--) {
							if (this.checkcoltype(cols[i])) {
								nextindex = i;
								coltype = cols[i].type;
								break;
							}
						}
					}
					if (nextindex > -1 && rowindex > -1) {
						if (rowindex < this.tablemain.length) {
							if(this.$refs[coltype + '_' + nextindex + '_' +rowindex ]!=undefined)
								this.$refs[coltype + '_' + nextindex + '_' +rowindex ][0].focus();
						}
						else if(rowindex==this.tablemain.length){
							this.autoaddrow(rowindex-1);
						}
					}
				}
			}
		},
		//自动添加行
		autoaddrow(rowindex){
			this.$emit('autoaddrow', {
				event: 'addrow',
				index:rowindex
			});
			var that=this;
			setTimeout(function() {
				that.setfoucsbyindex(rowindex,0, '',true);
			}, 200);
		},
		setuparrow(){
			this.$emit('setuparrow',{});
		},
		setgridfoucs(colindex,rowindex){
			if(this.tablemain.length>0)
			{
				var cols = this.columns;
				if(colindex==undefined)
					colindex=0;
				if(rowindex==undefined)
					rowindex=0;
				for (var i = colindex; i < cols.length; i++) {
					if (this.checkcoltype(cols[i])) {
						if(this.$refs[cols[i].type + '_' + i + '_'+rowindex]!=undefined)
							this.$refs[cols[i].type + '_' + i + '_'+rowindex][0].focus();
						break;
					}
				}
			}
		},
		//设置焦点到指定位置
		//rowindex--行索引  colindex--列索引   colname--列名
		setfoucsbyindex(rowindex,colindex,colname,isnext){
			if(isnext==undefined)
				isnext=false;
			if(colindex==undefined&&colname!=''){
				for(var i=0;i<this.columns.length;i++){
					if(this.columns[i].field==colname){
						colindex=i;
						break;
					}
				}
			}
			if(isnext)
			{
				for (var key in this.tablemain[rowindex]){
					if(this.tablemain[rowindex][key]!=''){
						rowindex++;
						break;
					}
				}
			}
			this.setgridfoucs(colindex,rowindex);
		},
		//检测列是否为可编辑列
		checkcoltype(col){
			return (col.colshow=='1'||col.colshow==undefined)&&(col.type == 'input' || col.type == 'select' || col.type == 'select_filter' || col.type == 'time')
		},
		//更新表字段
		UpdateCol(scope,rowindex,colname,keycol){
			//debugger
			var that=this;
			var tablename='',keyvalue='';
			if(this.tablemain[rowindex].tablename!=undefined)
				tablename=this.tablemain[rowindex].tablename;
			if(this.tablemain[rowindex][keycol]!=undefined)
				keyvalue=this.tablemain[rowindex][keycol];
			var paraminfo={
				tablename:tablename,
				colname:colname,
				colvalue:this.updatevalue,
				key:keycol,
				keyvalue:keyvalue
			}
			this.$apipost.post.UpdateGridCol({paraminfo:paraminfo}).then(res => {
				if(res.state=='1')
				{
					this.$tool.message('保存成功');
					that.tablemain[rowindex][colname]=that.updatevalue;
					that.updatevalue='';
					that.timestamp=parseInt(that.timestamp)+1;
					that.Closepopover(scope);
				}
				else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		Openpopover(scope,value){
			this.updatevalue=value;
			scope._self.$parent.$refs[`popover-${scope.$index}`][0].$children[0].focus();
		},
		Closepopover(scope){
			scope._self.$parent.$refs[`popover-${scope.$index}`][0].doClose();
		},
		getExpandsRow(index,row,expand){
			var that=this;
			row.expand=expand;
			if(expand){
				if(row.haschild=='1'){
					this.expands.push(row[this.rowkey]);
						this.$emit('getExpandsRow', {
							row: row,
							expand: expand,
							index:index
						});
				}
			}
			else
			{
				var list=this.expands.filter(e=>{
					return e==row[that.rowkey];
				});
				if(list.length>0){
					//this.$refs.tablegrid.toggleRowExpansion(this.tablemain[index],false);
					for(var i=0;i<this.expands.length;i++)
					{
						if(this.expands[i]==row[this.rowkey]){
							this.expands.splice(i,1);
							break;
						}
					}
				}
			}
		},
		SetExpandState(start,isexpand){
			var that=this;
			for(var i=start;i<this.tablemain.length;i++){
				if(this.tablemain[i].expand==undefined)
					this.tablemain[i].expand=isexpand;
				this.tablemain[i].sonDataList=[];
				this.getExpandsRow(i,this.tablemain[i],this.tablemain[i].expand);
			}
		},
		SetExpandSonList(index,list){
			//debugger
			//this.tablemain[index].sonDataList=list;
			this.$refs.tablegrid.toggleRowExpansion(this.tablemain[index],true);
		},
		SetTableList(list,isrefresh){
			var that=this;
			this.tablemain=list;
			if(isrefresh){
				this.tablemain.forEach(e=>{
					if(e.sonDataList!=undefined)
						this.$refs.tablegrid.toggleRowExpansion(e,false);
				});
			}
		},
		copyvalue(value){
			this.$tool.copyJSON(value);
		},
		colset(){
			
		}
	}
};
</script>
<style>
.selectTr td {
	background: rgba(219, 223, 232, 0.2) !important;
}
.airmain {
	width: 80%;
	td {
		text-align: left;
		padding-left: 0px;
	}
}
.el-table__expand-icon>.el-icon{
	display:none;
}
</style>
